import { AccordionSummary as MuiAccordionSummary } from '@mui/material';
import * as React from 'react';
import { TAccordionSummary } from './AccordionSummary.types';
import './Accordion.styles.scss';

export const AccordionSummary: TAccordionSummary = (props) => {
  return <MuiAccordionSummary className="accordion-summary" {...props} />;
};
